<template>
  <div>
    <base-title title="Início" />
  </div>
</template>

<script>
import BaseTitle from "@/components/Title";

export default {
  components: {
    BaseTitle,
  },
};
</script>

<style scoped>
</style>
